var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounCamera5521618(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "x",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.656-0.875c-0.76172 0.39844-1.5547 0.69531-2.375 0.89062-0.8125 0.19531-1.6641 0.29688-2.5469 0.29688-2.6562 0-4.7617-0.73828-6.3125-2.2188-1.5547-1.4883-2.3281-3.5039-2.3281-6.0469 0-2.5508 0.77344-4.5664 2.3281-6.0469 1.5508-1.4883 3.6562-2.2344 6.3125-2.2344 0.88281 0 1.7344 0.10156 2.5469 0.29688 0.82031 0.19922 1.6133 0.49609 2.375 0.89062v3.2969c-0.76172-0.51953-1.5117-0.89844-2.25-1.1406-0.74219-0.23828-1.5234-0.35938-2.3438-0.35938-1.4688 0-2.625 0.46875-3.4688 1.4062-0.83594 0.9375-1.25 2.2344-1.25 3.8906 0 1.6484 0.41406 2.9375 1.25 3.875 0.84375 0.9375 2 1.4062 3.4688 1.4062 0.82031 0 1.6016-0.11719 2.3438-0.35938 0.73828-0.23828 1.4883-0.61719 2.25-1.1406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.719-8.7031c-0.33594-0.15625-0.66797-0.26953-1-0.34375-0.32422-0.082031-0.65625-0.125-1-0.125-0.98047 0-1.7344 0.32031-2.2656 0.95312-0.53125 0.625-0.79688 1.5273-0.79688 2.7031v5.5156h-3.8125v-11.969h3.8125v1.9688c0.48828-0.78125 1.0508-1.3477 1.6875-1.7031 0.64453-0.36328 1.4102-0.54688 2.2969-0.54688 0.13281 0 0.27344 0.007812 0.42188 0.015625 0.14453 0.011719 0.36328 0.03125 0.65625 0.0625z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.781-6.0156v1.0938h-8.9375c0.09375 0.89844 0.41406 1.5703 0.96875 2.0156 0.55078 0.44922 1.3281 0.67188 2.3281 0.67188 0.80078 0 1.625-0.11719 2.4688-0.35938 0.84375-0.23828 1.7109-0.59766 2.6094-1.0781v2.9531c-0.90625 0.33594-1.8125 0.58984-2.7188 0.76562s-1.8125 0.26562-2.7188 0.26562c-2.1562 0-3.8398-0.54688-5.0469-1.6406-1.1992-1.1016-1.7969-2.6484-1.7969-4.6406 0-1.9453 0.58594-3.4766 1.7656-4.5938 1.1758-1.125 2.8008-1.6875 4.875-1.6875 1.875 0 3.375 0.57031 4.5 1.7031 1.1328 1.125 1.7031 2.6367 1.7031 4.5312zm-3.9375-1.2656c0-0.72656-0.21484-1.3125-0.64062-1.75-0.41797-0.44531-0.96875-0.67188-1.6562-0.67188-0.74219 0-1.3438 0.21094-1.8125 0.625-0.46094 0.41797-0.74609 1.0156-0.85938 1.7969z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.2031-5.3906c-0.80469 0-1.4062 0.13672-1.8125 0.40625-0.39844 0.27344-0.59375 0.67188-0.59375 1.2031 0 0.48047 0.16016 0.85938 0.48438 1.1406 0.32031 0.27344 0.77344 0.40625 1.3594 0.40625 0.71875 0 1.3203-0.25391 1.8125-0.76562 0.48828-0.51953 0.73438-1.1719 0.73438-1.9531v-0.4375zm5.8438-1.4375v6.8281h-3.8594v-1.7656c-0.51172 0.71875-1.0898 1.2461-1.7344 1.5781-0.63672 0.33203-1.418 0.5-2.3438 0.5-1.2422 0-2.2461-0.35938-3.0156-1.0781-0.77344-0.72656-1.1562-1.6719-1.1562-2.8281 0-1.3945 0.47656-2.4219 1.4375-3.0781 0.96875-0.65625 2.4883-0.98438 4.5625-0.98438h2.25v-0.29688c0-0.60156-0.24219-1.0469-0.71875-1.3281-0.48047-0.28125-1.2266-0.42188-2.2344-0.42188-0.8125 0-1.5742 0.085937-2.2812 0.25-0.71094 0.15625-1.3672 0.40234-1.9688 0.73438v-2.9219c0.82031-0.19531 1.6445-0.34766 2.4688-0.45312 0.82031-0.10156 1.6484-0.15625 2.4844-0.15625 2.1562 0 3.7109 0.42969 4.6719 1.2812 0.95703 0.84375 1.4375 2.2266 1.4375 4.1406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.0156-15.359v3.3906h3.9375v2.7344h-3.9375v5.0781c0 0.55469 0.10938 0.92969 0.32812 1.125 0.21875 0.19922 0.65625 0.29688 1.3125 0.29688h1.9688v2.7344h-3.2812c-1.5117 0-2.5859-0.3125-3.2188-0.9375-0.625-0.63281-0.9375-1.707-0.9375-3.2188v-5.0781h-1.9062v-2.7344h1.9062v-3.3906z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.9688-10.219v-6.4062h3.8594v16.625h-3.8594v-1.7344c-0.52344 0.71094-1.1016 1.2305-1.7344 1.5625-0.63672 0.32031-1.3711 0.48438-2.2031 0.48438-1.4688 0-2.6797-0.58203-3.625-1.75-0.94922-1.1758-1.4219-2.6875-1.4219-4.5312s0.47266-3.3477 1.4219-4.5156c0.94531-1.1758 2.1562-1.7656 3.625-1.7656 0.83203 0 1.5664 0.16797 2.2031 0.5 0.63281 0.32422 1.2109 0.83594 1.7344 1.5312zm-2.5156 7.75c0.82031 0 1.4453-0.29688 1.875-0.89062 0.42578-0.60156 0.64062-1.4727 0.64062-2.6094 0-1.1445-0.21484-2.0156-0.64062-2.6094-0.42969-0.59375-1.0547-0.89062-1.875-0.89062-0.8125 0-1.4336 0.29688-1.8594 0.89062-0.42969 0.59375-0.64062 1.4648-0.64062 2.6094 0 1.1367 0.21094 2.0078 0.64062 2.6094 0.42578 0.59375 1.0469 0.89062 1.8594 0.89062z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.2031-2.4688c0.82031 0 1.4453-0.29688 1.875-0.89062 0.42578-0.60156 0.64062-1.4727 0.64062-2.6094 0-1.1445-0.21484-2.0156-0.64062-2.6094-0.42969-0.59375-1.0547-0.89062-1.875-0.89062-0.82422 0-1.4531 0.30469-1.8906 0.90625-0.4375 0.59375-0.65625 1.4609-0.65625 2.5938 0 1.1367 0.21875 2.0078 0.65625 2.6094 0.4375 0.59375 1.0664 0.89062 1.8906 0.89062zm-2.5469-7.75c0.53125-0.69531 1.1133-1.207 1.75-1.5312 0.64453-0.33203 1.3828-0.5 2.2188-0.5 1.4688 0 2.6758 0.58984 3.625 1.7656 0.94531 1.168 1.4219 2.6719 1.4219 4.5156s-0.47656 3.3555-1.4219 4.5312c-0.94922 1.168-2.1562 1.75-3.625 1.75-0.83594 0-1.5742-0.16797-2.2188-0.5-0.63672-0.33203-1.2188-0.84766-1.75-1.5469v1.7344h-3.8125v-16.625h3.8125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "m",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.26562-11.969h3.8281l3.2188 8.125 2.7344-8.125h3.8125l-5.0312 13.094c-0.5 1.332-1.0898 2.2656-1.7656 2.7969-0.66797 0.53125-1.5547 0.79688-2.6562 0.79688h-2.2188v-2.5h1.2031c0.64453 0 1.1133-0.10547 1.4062-0.3125 0.30078-0.21094 0.53125-0.57812 0.6875-1.1094l0.10938-0.34375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "l",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156-15.953h4.1094v15.953h-4.1094z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "k",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.25-11.969h10.438v2.6719l-6.2969 6.5625h6.2969v2.7344h-10.703v-2.6719l6.2969-6.5625h-6.0312z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "w",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156-15.953h5.2188l3.6406 8.5469 3.6562-8.5469h5.2188v15.953h-3.8906v-11.656l-3.6719 8.5938h-2.6094l-3.6719-8.5938v11.656h-3.8906z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "j",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.859-7.2812v7.2812h-3.8438v-5.5469c0-1.0508-0.027344-1.7695-0.078125-2.1562-0.042969-0.39453-0.12109-0.6875-0.23438-0.875-0.14844-0.25-0.35156-0.44141-0.60938-0.57812-0.25-0.14453-0.54297-0.21875-0.875-0.21875-0.79297 0-1.418 0.3125-1.875 0.9375-0.46094 0.61719-0.6875 1.4648-0.6875 2.5469v5.8906h-3.8125v-16.625h3.8125v6.4062c0.58203-0.69531 1.1953-1.207 1.8438-1.5312 0.64453-0.33203 1.3594-0.5 2.1406-0.5 1.3828 0 2.4297 0.42969 3.1406 1.2812 0.71875 0.84375 1.0781 2.0742 1.0781 3.6875z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.922-9.9688c0.48828-0.75 1.0625-1.3164 1.7188-1.7031 0.66406-0.38281 1.3984-0.57812 2.2031-0.57812 1.375 0 2.4219 0.42969 3.1406 1.2812 0.71875 0.84375 1.0781 2.0742 1.0781 3.6875v7.2812h-3.8438v-6.2344c0.007812-0.09375 0.015625-0.1875 0.015625-0.28125v-0.4375c0-0.84375-0.125-1.457-0.375-1.8438-0.25-0.38281-0.65234-0.57812-1.2031-0.57812-0.73047 0-1.293 0.30469-1.6875 0.90625-0.38672 0.59375-0.58984 1.4609-0.60938 2.5938v5.875h-3.8438v-6.2344c0-1.3203-0.11719-2.1758-0.34375-2.5625-0.23047-0.38281-0.63672-0.57812-1.2188-0.57812-0.73047 0-1.2969 0.30469-1.7031 0.90625-0.39844 0.60547-0.59375 1.4648-0.59375 2.5781v5.8906h-3.8438v-11.969h3.8438v1.75c0.46875-0.66406 1.0039-1.1719 1.6094-1.5156 0.61328-0.34375 1.2891-0.51562 2.0312-0.51562 0.82031 0 1.5508 0.19922 2.1875 0.59375 0.63281 0.39844 1.1133 0.96094 1.4375 1.6875z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7031-4.6562v-7.3125h3.8438v1.2031c0 0.64844-0.007813 1.4609-0.015625 2.4375v1.9688c0 0.96094 0.023438 1.6523 0.078125 2.0781 0.050781 0.41797 0.13281 0.72656 0.25 0.92188 0.15625 0.25 0.35938 0.44531 0.60938 0.57812 0.25781 0.13672 0.55078 0.20312 0.875 0.20312 0.80078 0 1.4258-0.30469 1.875-0.92188 0.45703-0.61328 0.6875-1.4688 0.6875-2.5625v-5.9062h3.8281v11.969h-3.8281v-1.7344c-0.57422 0.69922-1.1836 1.2148-1.8281 1.5469-0.64844 0.33203-1.3555 0.5-2.125 0.5-1.3867 0-2.4453-0.42188-3.1719-1.2656-0.71875-0.85156-1.0781-2.0859-1.0781-3.7031z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "v",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.109-15.438v3.375c-0.875-0.39453-1.7305-0.69141-2.5625-0.89062-0.83594-0.19531-1.6211-0.29688-2.3594-0.29688-0.99219 0-1.7188 0.13672-2.1875 0.40625-0.46875 0.27344-0.70312 0.6875-0.70312 1.25 0 0.42969 0.15625 0.76172 0.46875 1 0.32031 0.24219 0.89844 0.44922 1.7344 0.625l1.75 0.34375c1.7695 0.35547 3.0312 0.89844 3.7812 1.625 0.75 0.73047 1.125 1.7617 1.125 3.0938 0 1.7617-0.52734 3.0742-1.5781 3.9375-1.043 0.85547-2.6328 1.2812-4.7656 1.2812-1.0117 0-2.0273-0.10156-3.0469-0.29688-1.0234-0.1875-2.043-0.46875-3.0625-0.84375v-3.4688c1.0195 0.53125 2.0039 0.9375 2.9531 1.2188 0.95703 0.27344 1.875 0.40625 2.75 0.40625 0.90625 0 1.5938-0.14453 2.0625-0.4375 0.47656-0.30078 0.71875-0.73438 0.71875-1.2969 0-0.48828-0.16406-0.86719-0.48438-1.1406-0.32422-0.26953-0.96875-0.51562-1.9375-0.73438l-1.5938-0.35938c-1.5938-0.33203-2.7617-0.875-3.5-1.625-0.74219-0.75-1.1094-1.7578-1.1094-3.0312 0-1.582 0.50781-2.8008 1.5312-3.6562 1.0312-0.85156 2.5078-1.2812 4.4375-1.2812 0.875 0 1.7734 0.070313 2.7031 0.20312 0.92578 0.125 1.8828 0.32422 2.875 0.59375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "u",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438-16.625h3.8125v9.0469l4.4062-4.3906h4.4375l-5.8438 5.5 6.3125 6.4688h-4.6406l-4.6719-4.9844v4.9844h-3.8125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "t",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438-11.969h3.8125v11.969h-3.8125zm0-4.6562h3.8125v3.125h-3.8125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "s",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.7031-16.625v2.5156h-2.1094c-0.54297 0-0.92188 0.10156-1.1406 0.29688-0.21094 0.19922-0.3125 0.53906-0.3125 1.0156v0.82812h3.2656v2.7344h-3.2656v9.2344h-3.8281v-9.2344h-1.8906v-2.7344h1.8906v-0.82812c0-1.3008 0.36328-2.2656 1.0938-2.8906 0.72656-0.625 1.8516-0.9375 3.375-0.9375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.5312-9.5156c-0.84375 0-1.4922 0.30859-1.9375 0.92188-0.44922 0.60547-0.67188 1.4805-0.67188 2.625 0 1.1484 0.22266 2.0273 0.67188 2.6406 0.44531 0.60547 1.0938 0.90625 1.9375 0.90625 0.83203 0 1.4688-0.30078 1.9062-0.90625 0.44531-0.61328 0.67188-1.4922 0.67188-2.6406 0-1.1445-0.22656-2.0195-0.67188-2.625-0.4375-0.61328-1.0742-0.92188-1.9062-0.92188zm0-2.7344c2.0508 0 3.6562 0.55859 4.8125 1.6719 1.1641 1.1055 1.75 2.6406 1.75 4.6094s-0.58594 3.5117-1.75 4.625c-1.1562 1.1055-2.7617 1.6562-4.8125 1.6562-2.0625 0-3.6797-0.55078-4.8438-1.6562-1.168-1.1133-1.75-2.6562-1.75-4.625s0.58203-3.5039 1.75-4.6094c1.1641-1.1133 2.7812-1.6719 4.8438-1.6719z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "r",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156-15.953h4.5781l5.8125 10.938v-10.938h3.8906v15.953h-4.5938l-5.7969-10.938v10.938h-3.8906z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "q",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.859-7.2812v7.2812h-3.8438v-5.5781c0-1.0312-0.027344-1.7383-0.078125-2.125-0.042969-0.39453-0.12109-0.6875-0.23438-0.875-0.14844-0.25-0.35156-0.44141-0.60938-0.57812-0.25-0.14453-0.54297-0.21875-0.875-0.21875-0.79297 0-1.418 0.3125-1.875 0.9375-0.46094 0.61719-0.6875 1.4648-0.6875 2.5469v5.8906h-3.8125v-11.969h3.8125v1.75c0.58203-0.69531 1.1953-1.207 1.8438-1.5312 0.64453-0.33203 1.3594-0.5 2.1406-0.5 1.3828 0 2.4297 0.42969 3.1406 1.2812 0.71875 0.84375 1.0781 2.0742 1.0781 3.6875z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "p",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156-15.953h6.8125c2.0312 0 3.5859 0.45312 4.6719 1.3594 1.0938 0.89844 1.6406 2.1797 1.6406 3.8438 0 1.6797-0.54688 2.9688-1.6406 3.875-1.0859 0.89844-2.6406 1.3438-4.6719 1.3438h-2.7031v5.5312h-4.1094zm4.1094 2.9844v4.4531h2.2656c0.80078 0 1.4141-0.19141 1.8438-0.57812 0.4375-0.38281 0.65625-0.9375 0.65625-1.6562 0-0.70703-0.21875-1.2539-0.65625-1.6406-0.42969-0.38281-1.043-0.57812-1.8438-0.57812z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "o",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438-11.969h3.8125v11.75c0 1.6016-0.38672 2.8281-1.1562 3.6719-0.76172 0.84375-1.8711 1.2656-3.3281 1.2656h-1.8906v-2.5h0.65625c0.72656 0 1.2266-0.16797 1.5-0.5 0.26953-0.32422 0.40625-0.96875 0.40625-1.9375zm0-4.6562h3.8125v3.125h-3.8125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "n",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5-11.594v3.125c-0.52344-0.35156-1.043-0.61328-1.5625-0.78125-0.52344-0.17578-1.0625-0.26562-1.625-0.26562-1.0742 0-1.9062 0.3125-2.5 0.9375s-0.89062 1.4961-0.89062 2.6094c0 1.1172 0.29688 1.9844 0.89062 2.6094s1.4258 0.9375 2.5 0.9375c0.59375 0 1.1562-0.085937 1.6875-0.26562 0.53906-0.17578 1.0391-0.44141 1.5-0.79688v3.125c-0.59375 0.23047-1.1992 0.39453-1.8125 0.5-0.61719 0.11328-1.2344 0.17188-1.8594 0.17188-2.1562 0-3.8438-0.55078-5.0625-1.6562-1.2188-1.1133-1.8281-2.6562-1.8281-4.625s0.60938-3.5039 1.8281-4.6094c1.2188-1.1133 2.9062-1.6719 5.0625-1.6719 0.625 0 1.2383 0.058594 1.8438 0.17188 0.61328 0.10547 1.2227 0.26562 1.8281 0.48438z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.38 497.84-232.39-84.586c-3.7656-1.3711-6.832-4.1797-8.5234-7.8086-1.6953-3.6328-1.875-7.7852-0.50391-11.551l92.848-255.1c1.3711-3.7656 4.1797-6.832 7.8125-8.5234 3.6289-1.6953 7.7852-1.875 11.547-0.50391l232.39 84.582c3.7656 1.3711 6.832 4.1797 8.5234 7.8125 1.6914 3.6289 1.875 7.7812 0.50391 11.547l-92.848 255.11c-1.3711 3.7617-4.1797 6.8281-7.8125 8.5234-3.6289 1.6914-7.7852 1.8711-11.547 0.50391zm-191.34-153.23 204.01 74.254 65.988-181.3-204.01-74.254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.24 109.11 36.73-13.371 11.211 30.809 37.078 13.48-25.062-68.828c-1.3672-3.7656-4.1758-6.8359-7.8086-8.5273-3.6289-1.6914-7.7852-1.8711-11.551-0.5l-232.4 84.586c-3.7656 1.3672-6.832 4.1758-8.5234 7.8086-1.6953 3.6289-1.875 7.7852-0.5 11.551l70.598 193.96 16.082-44.18-53.117-145.91 123.23-44.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.41 270.84c-8.6836-3.1602-18.266-2.7422-26.637 1.1602-8.375 3.9062-14.855 10.977-18.016 19.66-3.1602 8.6797-2.7422 18.262 1.1641 26.637s10.977 14.852 19.656 18.012c8.6836 3.1602 18.266 2.7422 26.641-1.1602 8.3711-3.9062 14.852-10.977 18.012-19.66 3.1602-8.6797 2.7383-18.262-1.1641-26.637-3.9062-8.3711-10.977-14.852-19.656-18.012zm-0.0625 53.547c1.8047-28.559-14.441-39.707-20.922-42.992 7.582-3.1016 16.223-2.1172 22.914 2.6133 6.6875 4.7305 10.496 12.551 10.09 20.734-0.40234 8.1836-4.9609 15.594-12.082 19.645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.86 258.98-1.8516-14.133c-0.625-4.7852-3.8633-8.8203-8.3984-10.473l-44.031-16.027c-4.5352-1.6484-9.6133-0.63672-13.168 2.625l-10.5 9.6367c-3.5547 3.2617-8.6328 4.2734-13.164 2.6211l-25.469-9.2695c-4.3906-1.5977-9.2461 0.66797-10.844 5.0586l-2.7539 7.5703v-0.003906c-0.45703 1.2578 0.19141 2.6445 1.4453 3.0977l17.977 6.543v0.003906c5.0156 1.8242 7.6055 7.3711 5.7773 12.387-1.8242 5.0195-7.3711 7.6055-12.391 5.7773l-17.977-6.543c-1.2539-0.45703-2.6406 0.19141-3.0977 1.4453l-21.215 58.289c-1.5977 4.3906 0.66406 9.2422 5.0547 10.84l150.45 54.762c4.3906 1.5977 9.2461-0.66797 10.844-5.0586l32.234-88.566c1.5977-4.3906-0.66406-9.2422-5.0547-10.84l-25.469-9.2695c-4.5352-1.6523-7.7734-5.6875-8.3984-10.473zm-75.66 86.605c-11.141-4.0547-20.219-12.371-25.23-23.117-5.0078-10.746-5.5469-23.043-1.4922-34.188 4.0547-11.141 12.371-20.215 23.117-25.227 10.75-5.0117 23.047-5.5469 34.188-1.4922 11.145 4.0547 20.219 12.371 25.23 23.117s5.5469 23.043 1.4922 34.188c-4.0586 11.141-12.375 20.215-23.121 25.223-10.746 5.0117-23.043 5.5508-34.184 1.4961zm80.793-35.316c-3.6875-1.3438-6.6953-4.0977-8.3516-7.6523-1.6602-3.5586-1.8398-7.6328-0.49609-11.32s4.0977-6.6914 7.6562-8.3516c3.5547-1.6602 7.6289-1.8359 11.316-0.49609 3.6875 1.3438 6.6953 4.0977 8.3516 7.6562 1.6602 3.5586 1.8398 7.6289 0.49609 11.316-1.3438 3.6914-4.0977 6.6953-7.6562 8.3516-3.5547 1.6602-7.6289 1.8398-11.316 0.49609z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 625.625,
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("use", {
    x: 86.054688,
    y: 625.625,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96.839844,
    y: 625.625,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 111.679687,
    y: 625.625,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 126.4375,
    y: 625.625,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 136.894531,
    y: 625.625,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 151.730469,
    y: 625.625,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 175.007812,
    y: 625.625,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 190.664062,
    y: 625.625,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 212.539062,
    y: 625.625,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 220.679688,
    y: 625.625,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 233.410156,
    y: 625.625,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 248.171875,
    y: 625.625,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.519531,
    y: 625.625,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    x: 290.289062,
    y: 625.625,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.050781,
    y: 625.625,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.621094,
    y: 625.625,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.417969,
    y: 625.625,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.988281,
    y: 625.625,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 382.261719,
    y: 625.625,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 398.019531,
    y: 625.625,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 412.78125,
    y: 625.625,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 427.328125,
    y: 625.625,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 434.824219,
    y: 625.625,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 647.5,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 79.515625,
    y: 647.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.304688,
    y: 647.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 105.332031,
    y: 647.5,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 135.742188,
    y: 647.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 146.199219,
    y: 647.5,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 161.773438,
    y: 647.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 184.222656,
    y: 647.5,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 202.53125,
    y: 647.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 217.558594,
    y: 647.5,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 233.132812,
    y: 647.5,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.320312,
    y: 647.5,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.355469,
    y: 647.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.140625,
    y: 647.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.171875,
    y: 647.5,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.667969,
    y: 647.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.503906,
    y: 647.5,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.472656,
    y: 647.5,
    xlinkHref: "#c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounCamera5521618);
export default __webpack_public_path__ + "static/media/noun-camera-5521618.6eb0ca9de9bd01fdf282683ebc936303.svg";
export { ForwardRef as ReactComponent };